import { Add, ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Box,
  Collapse,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import { MuiRTL } from 'lib/MuiRTL';
import { Fragment } from 'react';

const ExitListSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="لیست جمع آوری" />
    </ListItemButton>
  );
};

const DockSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="بارانداز" />
    </ListItemButton>
  );
};

const ProductListSidebarItem = ({ active, onClick }) => {
  return (
    <ListItemButton selected={active} onClick={onClick}>
      <ListItemText primary="لیست محصول" />
    </ListItemButton>
  );
};

const AgentsSidebarItem = ({
  agents,
  expanded,
  selectedAgentGuid,
  onToggle,
  onSelectAgent,
  onAddAgent,
  canAddAgent,
}) => {
  return (
    <Fragment>
      <ListItemButton onClick={onToggle}>
        <ListItemText primary="لیست انباردار‌ها" />
        {canAddAgent ? (
          <IconButton
            size="small"
            edge="end"
            aria-label="افزودن PDA"
            onClick={event => {
              event.stopPropagation();
              onAddAgent?.();
            }}
          >
            <Add fontSize="small" />
          </IconButton>
        ) : null}
        {agents.length > 0 ? expanded ? <ExpandLess /> : <ExpandMore /> : null}
      </ListItemButton>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {agents.map(agent => (
            <ListItemButton
              key={agent.operationAgentGuid || agent.guid}
              sx={{ pl: 4 }}
              selected={
                selectedAgentGuid === (agent.operationAgentGuid || agent.guid)
              }
              onClick={() => onSelectAgent(agent)}
            >
              <ListItemText primary={agent.name} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </Fragment>
  );
};

export const WorkspaceSidebar = ({
  agents = [],
  expandedAgents,
  selectedSection,
  onSelectSidebarItem,
  onToggleAgents,
  onAddAgent,
  canAddAgent = true,
}) => {
  return (
    <Box sx={{ width: '220px' }}>
      <MuiRTL>
        <List
          dir="rtl"
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <ExitListSidebarItem
            active={selectedSection.type === 'exitList'}
            onClick={() => onSelectSidebarItem('exitList')}
          />

          <ProductListSidebarItem
            active={selectedSection.type === 'productList'}
            onClick={() => onSelectSidebarItem('productList')}
          />

          <DockSidebarItem
            active={
              selectedSection.type === 'dock' || selectedSection.type === 'cart'
            }
            onClick={() => onSelectSidebarItem('dock')}
          />

          <AgentsSidebarItem
            agents={agents}
            expanded={expandedAgents}
            selectedAgentGuid={
              selectedSection.type === 'agent' ? selectedSection.guid : null
            }
            onToggle={onToggleAgents}
            onSelectAgent={agent => onSelectSidebarItem('agent', agent)}
            onAddAgent={onAddAgent}
            canAddAgent={canAddAgent}
          />
        </List>
      </MuiRTL>
    </Box>
  );
};
